import GridBackground from "@/components/primitives/GridBackground";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-tca-ink-dim/30 bg-tca-deep overflow-hidden"
        >
            <GridBackground fine />
            <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-14 sm:py-20">
                {/* Top row */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 items-center">
                    {/* Left: logo (responsive — stacked on mobile, horizontal on md+) */}
                    <div className="flex items-center gap-3">
                        <img
                            src="/brand/logo-stacked.svg"
                            alt="The Creator's Agent"
                            className="md:hidden h-12 w-12 opacity-95"
                            data-testid="footer-logo-stacked"
                        />
                        <img
                            src="/brand/logo.png"
                            alt="The Creator's Agent"
                            className="hidden md:block h-7 w-auto opacity-90"
                            data-testid="footer-logo"
                        />
                    </div>

                    {/* Center: tagline */}
                    <div className="text-center">
                        <div className="font-display text-2xl sm:text-3xl text-tca-ink leading-tight">
                            The Future is{" "}
                            <span className="italic gold-brushed">Yours to Engineer.</span>
                        </div>
                    </div>

                    {/* Right: domain */}
                    <div className="md:text-right">
                        <a
                            href="https://thecreatorsagent.com"
                            data-testid="footer-domain"
                            className="
                                font-mono-tight text-sm tracking-[0.18em]
                                text-tca-cyan hover:text-tca-cyan-hi
                                transition-colors
                            "
                        >
                            thecreatorsagent.com
                        </a>
                    </div>
                </div>

                {/* Divider */}
                <div className="my-10 h-px bg-gradient-to-r from-transparent via-tca-cyan/25 to-transparent" />

                {/* Meta row */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono-tight text-[11px] tracking-[0.18em] uppercase text-tca-ink-muted">
                    <div data-testid="footer-copyright">
                        © 2026 The Creator&apos;s Agent, LLC
                    </div>
                    <div className="text-tca-ink-muted/80">
                        A node in the{" "}
                        <span className="text-tca-cyan">Smithers</span> ecosystem
                    </div>
                    <div className="flex items-center gap-5">
                        <a href="#access" className="hover:text-tca-cyan transition-colors" data-testid="footer-link-build-path">
                            Build Path Access
                        </a>
                        <a href="#privacy" className="hover:text-tca-cyan transition-colors" data-testid="footer-link-privacy">
                            Privacy
                        </a>
                        <a href="#terms" className="hover:text-tca-cyan transition-colors" data-testid="footer-link-terms">
                            Terms
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
